import styled, { keyframes } from "styled-components";
import { orangeColor, questionDarkTextColor } from "../../constants/colors";
import { LOADER_ANIMATION_TIME } from "../../constants/data";

const LoaderBlock = styled.div`
  //height: 100vh;
  flex-grow: 1;
  background: ${questionDarkTextColor};
  display: flex;
  position: relative;
`;

const opacityAnimation = keyframes`
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

LoaderBlock.Img = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  &.anim {
    animation: ${opacityAnimation} infinite
      ${LOADER_ANIMATION_TIME / 1000 + "s"} linear;
  }
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(5, 2, 55, 0) 0%, #050237 88.93%);
    //transform: rotate(-180deg);
  }
`;

LoaderBlock.Wrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-top: 83px;
  padding-bottom: 37px;
`;
LoaderBlock.Top = styled.div`
  &.anim {
    animation: ${opacityAnimation} infinite
      ${LOADER_ANIMATION_TIME / 1000 + "s"} linear;
  }
`;
LoaderBlock.Bottom = styled.div``;

LoaderBlock.Loader = styled.div`
  width: 35px;
  height: 35px;
  margin: 0 auto;
  animation: ${rotateAnimation} infinite ${LOADER_ANIMATION_TIME / 1000 + "s"}
    linear;
`;

LoaderBlock.Text = styled.div`
  margin-top: 20px;
`;

export { LoaderBlock };
